// @ts-strict-ignore
import React from 'react'
import { getValue } from '../../../utils/product-schema'
import { ProviderImage } from '../../../atoms/image'
import ejs from 'ejs/ejs'
import { Eligibility } from './eligibility'
import { ScoreDial } from './score-dial'
import { MoneyVoiceAccordion } from './accordion'

const createTopPicksError = (
  productName: string,
  path: string,
  contentfulId: string,
  element: string,
) => {
  fetch('https://www.money.co.uk/opsgenie/error', {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      message: `money voice top pick ${element} missing for ${productName} on ${path}`,
      tags: [`moneyVoiceTopPick${element}`],
      alias: contentfulId,
    }),
  })
}

function formatGetValue(value, data) {
  const val = getValue(value, data)

  if (typeof val === 'boolean') {
    return val ? 'Yes' : 'No'
  }

  return val
}
const getAuthorEntity = (id, includes) => {
  if (!id) {
    return undefined
  }
  return includes.find((i) => i.sys.id === id)
}

const ProsConsList = ({ title, items }) => (
  <div className='money-voice-top-picks__accordion__content__proscons'>
    <div className='money-voice-top-picks__accordion__content__proscons__title'>{title}</div>
    {items.map((item, index) => (
      <li key={index}>{item}</li>
    ))}
  </div>
)

export const MoneyVoiceTopPickCard = (
  data: any,
  variant: string,
  rawName: string,
  sys: { id: string },
  product: any,
  review: any,
  includes: any,
  brand: 'money' | 'uswitch',
  path: string,
  score: number,
) => {
  const productName = getValue(product.name, data)
  const miniReview = review?.fields?.minireview

  if (!miniReview && brand === 'money') {
    createTopPicksError(productName, path, sys.id, 'Reviews')
  }

  const cardPros = review?.fields.pros
  const cardCons = review?.fields.cons

  if ((!cardPros || !cardCons) && brand === 'money') {
    createTopPicksError(productName, path, sys.id, 'ProsAndCons')
  }

  const id = data._id
  const cardImage = getValue(product.image, data)
  const accountDetails = getValue(product.accountDetails, data)
  const author = getAuthorEntity(review?.fields?.author?.sys?.id, includes)
  const eligibilityCriteria = product.eligibilityCriteria

  const ctaLink = getValue(product.ctaLink, data)
  const ctaText = getValue(product.ctaText, data)
  const methodLink = product.methodLink?.value
  const methodText = product.methodText?.value

  const authorTitle = author && `${author.fields.name}, our savings expert says..`

  const MONEY_VOICE_ACCORDION_CLICKED = 'Money Voice Accordion Clicked'
  const MONEY_VOICE_CTA_CLICKED = 'Money Voice CTA Clicked'
  const MONEY_VOICE_METHOD_CLICKED = 'Money Voice Method Clicked'
  const MONEY_VOICE_TOP_PICK_VIEWED = 'Money Voice Top Pick Viewed'

  const dataTracking = (event_name, title?, href?) => ({
    component_category: 'component',
    component_id: sys?.id,
    component_name: 'MoneyVoiceTopPick',
    contentful_name: rawName,
    contentful_variant: variant,
    event_name,
    additionalProps: {
      id,
      name: productName,
      title,
      href,
    },
  })

  return (
    <>
      <div
        className='money-voice-top-picks__card__wrap'
        data-view-tracking={JSON.stringify(dataTracking(MONEY_VOICE_TOP_PICK_VIEWED))}
      >
        <div className='money-voice-top-picks__card__wrap__top-section'>
          <div className='money-voice-top-picks__card__title'>
            <div className='money-voice-top-picks__card__img-container'>
              {cardImage && (
                <ProviderImage src={cardImage} alt='Card' variant='xsmall' critical={false} />
              )}
            </div>
            <div className='money-voice-top-picks__card__title_text'>{productName}</div>
          </div>
          <div className='money-voice-top-picks__card__details_cells'>
            {product.productDetails.map((item: any, index: number) => {
              let currentLabel = item.label
              let currentValue = formatGetValue(item.value, data)
              if (item.label.slice && item.value.slice) {
                const labelArray = item.label.slice
                currentLabel = formatGetValue(item.label, data)
                  .split(' ')
                  .slice(...labelArray)
                  .join(' ')
                const valueArray = item.value.slice
                currentValue = formatGetValue(item.value, data)
                  .split(' ')
                  .slice(...valueArray)
                  .join(' ')
              }
              return (
                <div
                  className={`money-voice-top-picks__card__details_table-rows money-voice-top-picks__card__details_table-rows--${index}`}
                  key={index}
                >
                  <div className='money-voice-top-picks__card__details_table-rows__value'>
                    {currentValue}
                  </div>
                  <div className='money-voice-top-picks__card__details_table-rows__name'>
                    {currentLabel}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        {score && methodLink && methodText && (
          <div className='money-voice-top-picks__card__expert-score'>
            <a
              data-click-tracking={JSON.stringify(
                dataTracking(MONEY_VOICE_METHOD_CLICKED, methodText, methodLink),
              )}
              href={methodLink}
              target='_blank'
              rel='noopener noreferrer nofollow'
            >
              <div className='money-voice-top-picks__card__expert-score__icon'>{methodText}</div>
            </a>

            <div className='money-voice-top-picks__card__expert-score__score'>
              <div className='money-voice-top-picks__card__expert-score__score_text'>
                Expert verdict
              </div>
              <ScoreDial score={score} />
            </div>
          </div>
        )}
        <a
          className='money-voice-top-picks__card__cta_button'
          href={ctaLink}
          data-click-tracking={JSON.stringify(
            dataTracking(MONEY_VOICE_CTA_CLICKED, ctaText, ctaLink),
          )}
          target='_blank'
          rel='noopener noreferrer'
        >
          <div className='money-voice-top-picks__card__cta_button_text'>{ctaText}</div>
        </a>
      </div>
      <div className='money-voice-top-picks__accordions'>
        {miniReview && (
          <MoneyVoiceAccordion
            dataTrackingObject={dataTracking(MONEY_VOICE_ACCORDION_CLICKED, authorTitle)}
            title={authorTitle}
            open={true}
          >
            {`"${ejs.render(review.fields.minireview, data)}"`}
          </MoneyVoiceAccordion>
        )}
        {cardPros && cardCons && (
          <MoneyVoiceAccordion
            dataTrackingObject={dataTracking(MONEY_VOICE_ACCORDION_CLICKED, 'Pros and cons')}
            title='Pros and cons'
          >
            <ProsConsList title='Pros' items={cardPros} />
            <ProsConsList title='Cons' items={cardCons} />
          </MoneyVoiceAccordion>
        )}
        {accountDetails && (
          <MoneyVoiceAccordion
            dataTrackingObject={dataTracking(MONEY_VOICE_ACCORDION_CLICKED, 'Account details')}
            title='Account details'
          >
            {accountDetails}
          </MoneyVoiceAccordion>
        )}
        {eligibilityCriteria && (
          <MoneyVoiceAccordion
            dataTrackingObject={dataTracking(MONEY_VOICE_ACCORDION_CLICKED, 'Eligibility')}
            title='Eligibility'
          >
            <Eligibility criteria={eligibilityCriteria} data={data} />
          </MoneyVoiceAccordion>
        )}
      </div>
    </>
  )
}
